<p-toast></p-toast>
<div class="full-screen">
  <div class="cabecera">
    <app-logout cabecera="Panel Administración Leads" style="width: 100%;"></app-logout>
  </div>
  <div class="tabla">
    <div style="height: 100%;">
      <app-menubar [opciones]="opciones_menu"></app-menubar>
    </div>
    <app-tabla [filtersEnabled]="true" [data]="lista_usuarios" [columns]="columnas" style="overflow: auto; height: 100%;">
      <ng-template pTemplate="kdHeaderStart" let-rowData>
        <th></th>
        <th></th>
      </ng-template>
        <ng-template pTemplate="kdBodyStart" let-rowData>
          <td>
            <p-button type="button" icon="pi pi-pencil"  [rounded]="true" [outlined]="true" (click)="editarUsuario(rowData)"
            pTooltip="Editar Usuario" tooltipPosition="top"/>        
          </td>
          <td>
            <p-button type="button" icon="pi pi-eye" [rounded]="true" [outlined]="true" severity="danger"
            (click)="verProductosAsociados(rowData)" pTooltip="Ver Productos Asociados" tooltipPosition="top"/> 
          </td>
        </ng-template>
    </app-tabla>
  </div>
</div>

<p-dialog [(visible)]="dialog" [modal]="true" [style]="{width: '50vw', height: '90vh'}" [draggable]="false">
  <div *ngIf="tipo_dialogo === 'productos'">
    <app-tabla [columns]="columnas_productos" [data]="lista_productos" [rows]="3" [filtersEnabled]="true">
    </app-tabla>
  </div>
  <div *ngIf="tipo_dialogo == 'editar'">
    <app-formulario [formulario]="formulario_editar_usuario" [data]="datos_usuario_seleccionado" (enviarFormulario)="onRecibirFormulario($event)"></app-formulario>
  </div>
</p-dialog>
